// extracted by mini-css-extract-plugin
module.exports = {"RejectedProducts__table":"RejectedProducts_RejectedProducts__table__1drBi"};